export default "__VITE_PUBLIC_ASSET__213dbaa5__"